import { PAYMENT_COLLACTION_TYPE } from 'src/app/constants';
import { BillingInformation } from './payment.models';

export class Token {
  tokenId: number;
  terminalId: number;
  patientId: number;
  practiceId: number;
  merchantId: number;
  tokenString: string;
  timesUsed: string;
  status: string;
  created: string;
  createdByName: string;
  updated: string;
  expDate: string;
  lastFourDigits: string;
  cardType: string;
  tokenStatus: string;
  tokenType: number;
  preference: number;
  individualName: string;
  bankName: string;
  accountNumber: string;
  isActive: boolean = false;
  billingAddress: BillingInformation = new BillingInformation();
  isUsedInPaymentPlan: boolean = false;
  ownerType?: number; // 1 for Patient, 2 for Practice

  routingNumber: any;
  checkName: any;
  isDeleted: any;
  transactionType: any;
  exchangeId: any;
  code: any;
  bin: any;
  payloadType: any;
  jwt: any;

}

export class TokenByExpDate {
  active: Token[] = [];
  expiringSoon: Token[] = [];
  expired: Token[] = [];
}

export class TokenizedCard {
  patientId: number;
  practiceId: number;
  customerId: number;
  providerId: number;
  subject: string;
  note?: string;
  tokenizeResponse: TokenizedResponse;
  bankName: string;
  individualName: string;
  billingInformation: BillingInformation;
  transactionCollectionType?: PAYMENT_COLLACTION_TYPE;
  paymentPlanId?: number;
  paymentPlanEmiId?: number;
  ownerType: number; // 1 for Patient, 2 for Practice
  taxPercentage?: number; // Percentage of tax applied
  taxAmount?: number; // Amount of tax applied
  grossAmount?: number; // Total amount including tax
  preference?: number;
}

export class TokenizedResponse {
  code: string;
  status: string;
  exchangeId: string;
  payload: TokenizedResponsePayload;
}

export class TokenizedResponsePayload {
  mobilejwt: TokenizedResponsePayloadMobileJwtRequest;
  payloadType: string;
}

export class ClearentPaymentTokenResponse {
  code: string;
  status: string;
  'exchange-id': string;
  payload: ClearentPaymentTokenResponsePayload;
}

export class ClearentPaymentTokenResponsePayload {
  'mobile-jwt': TokenizedResponsePayloadMobileJwt;
  payloadType: string;
}

export class TokenizedResponsePayloadMobileJwt {
  jwt: string;
  bin: string;
  'last-four': string;
  'card-type': string;
  'exp-date': string;
}

export class TokenizedResponsePayloadMobileJwtRequest {
  jwt: string;
  bin: string;
  lastFour: string;
  cardType: string;
  expDate: string;
}

export class ChargeCardToken {
  tokenId: number;
  customerId: number;
  patientId: number;
  practiceId: number;
  providerId: number;
  amount: string;
  billingInformation: BillingInformation;
  bankName: string;
  individualName: string;
  subject: string;
  note?: string;
  isPrePayment: boolean = false;
  pmsPaymentType: number;
  transactionCollectionType?: PAYMENT_COLLACTION_TYPE;
  moduleType?: number;
  paymentPlanId?: number;
  paymentPlanEmiId?: number;
  description?: string = '';
  ownerType?: number; // 1 for Patient, 2 for Practice
  taxPercentage?: number; // Percentage of tax applied
  taxAmount?: number; // Amount of tax applied
  grossAmount?: number; // Total amount including tax
  patientName?:string='';
  retriedForTransactionId?:number[] | any = null; // For Fix It
  invoiceId?:number;
  emiTransactionType? : number;
}

export class ChargeACHToken {
  tokenId: number;
  customerId: number;
  patientId: number;
  practiceId: number;
  providerId: number;
  amount: string;
  individualName: string;
  billingInformation: BillingInformation = new BillingInformation();
  subject: string;
  note?: string;
  isPrePayment: boolean = false;
  pmsPaymentType: number;
  transactionCollectionType?: PAYMENT_COLLACTION_TYPE;
  moduleType?: number;
  paymentPlanId?: number;
  paymentPlanEmiId?: number;
  description?: string = '';
  ownerType?: number; // 1 for Patient, 2 for Practice
  patientName?:string='';
  retriedForTransactionId?:number[] | any = null; // For Fix It
  emiTransactionType? : number;
}

export class ACHToken {
  patientId: number;
  practiceId: number;
  customerId: number;
  providerId: number;
  accountNumber: string;
  accountType: string;
  routingNumber: string;
  individualName: string;
  bankName: string;
  amount: string;
  createToken: boolean = false;
  makePayment: boolean = false;
  billingInformation: BillingInformation = new BillingInformation();
  subject: string;
  note?: string;
  isPrePayment: boolean = false;
  pmsPaymentType: number;
  transactionCollectionType?: PAYMENT_COLLACTION_TYPE;
  moduleType?: number;
  paymentPlanId?: number;
  paymentPlanEmiId?: number;
  description?: string = '';
  ownerType?: number; // 1 for Patient, 2 for Practice
  patientName?:string='';
  retriedForTransactionId?:number[] | any = null; // For Fix It
  emiTransactionType? : number;
}

export class TokenPreference {
  tokenId: number;
  patientId?: number;
  practiceId: number;
  ownerType?: number;
  preference: number;
}
